
import { useState } from 'react';

interface UseChartDataProps {
  pricePerUnit: number;
  discountRate: number;
  orderVolume: number;
  costPerUnit: number;
}

export const useChartData = (props: UseChartDataProps) => {
  const [marginChartData, setMarginChartData] = useState<any[]>([]);
  const [discountChartData, setDiscountChartData] = useState<any[]>([]);
  const [costChartData, setCostChartData] = useState<any[]>([]);
  const [volumeChartData, setVolumeChartData] = useState<any[]>([]);

  const updateMarginChartData = (currentMargin: number) => {
    const priceChartData = [];
    for (let i = -100; i <= 100; i += 1) {
      const adjustedPrice = props.pricePerUnit * (1 + i / 100);
      const adjustedRevenue = adjustedPrice * props.orderVolume * (1 - props.discountRate / 100);
      const adjustedCost = props.costPerUnit * props.orderVolume;
      const adjustedGrossProfit = adjustedRevenue - adjustedCost;
      const adjustedMargin = adjustedRevenue > 0 ? adjustedGrossProfit / adjustedRevenue * 100 : -100;
      const clampedMargin = Math.max(adjustedMargin, -100);
      
      priceChartData.push({
        change: i,
        margin: clampedMargin
      });
    }
    setMarginChartData(priceChartData);

    const newCostChartData = [];
    for (let i = -100; i <= 100; i += 1) {
      const adjustedCostPerUnit = props.costPerUnit * (1 + i / 100);
      const adjustedTotalCost = adjustedCostPerUnit * props.orderVolume;
      const currentRevenue = props.pricePerUnit * props.orderVolume * (1 - props.discountRate / 100);
      const adjustedGrossProfit = currentRevenue - adjustedTotalCost;
      const adjustedMargin = currentRevenue > 0 ? adjustedGrossProfit / currentRevenue * 100 : -100;
      const clampedMargin = Math.max(adjustedMargin, -100);
      
      newCostChartData.push({
        change: i,
        margin: clampedMargin
      });
    }
    setCostChartData(newCostChartData);
  };

  return {
    marginChartData,
    discountChartData,
    costChartData,
    volumeChartData,
    updateMarginChartData
  };
};
